export const getIsTimeResolution = (dateValues: any, values: any) =>
  !dateValues.includes(values?.['Measure']) &&
  (values?.['Time Resolution']?.includes('-') || values?.['Formation Period']?.includes('-'));
